var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyCore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1551",
    "data-name": "Rectangle 1551",
    width: 16,
    height: 16,
    transform: "translate(-0.144 -0.144)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company_Core_Purpose",
    "data-name": "Company Core Purpose",
    transform: "translate(-590 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(590 301.662)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31615",
    "data-name": "Group 31615",
    transform: "translate(597.145 308.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31614",
    "data-name": "Group 31614",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11971",
    "data-name": "Path 11971",
    d: "M13.259,6.717a.548.548,0,0,1,1.066-.258A7.261,7.261,0,1,1,8.972,1.108a.548.548,0,0,1-.257,1.066,6.159,6.159,0,1,0,4.544,4.544Z",
    transform: "translate(0 0.28)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11972",
    "data-name": "Path 11972",
    d: "M9.036,7.33a.548.548,0,1,1,1.1,0A3.708,3.708,0,1,1,6.424,3.62a.549.549,0,0,1,0,1.1A2.612,2.612,0,1,0,9.036,7.33Z",
    transform: "translate(0.84 1.12)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    d: "M13.155,3.171,10.92,5.406a.549.549,0,0,1-.388.16H8.3a.547.547,0,0,1-.547-.547V2.784A.549.549,0,0,1,7.91,2.4L10.145.161a.548.548,0,0,1,.907.215l.473,1.415,1.415.473a.547.547,0,0,1,.213.907Zm-1.4-.148-.834-.279A.553.553,0,0,1,10.57,2.4l-.278-.834L8.846,3.01V4.47h1.46Z",
    transform: "translate(2.398 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11974",
    "data-name": "Path 11974",
    d: "M8.7,3.574a.548.548,0,1,1,.775.775L6.125,7.7a.548.548,0,1,1-.775-.775Z",
    transform: "translate(1.606 1.056)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCore);
export default __webpack_public_path__ + "static/media/company-core.609464cd05991d68fd1a55ba51e5f851.svg";
export { ForwardRef as ReactComponent };